import { displaySidebarLogos } from '~src/sidebar/index';

import { sidebarLoader } from '~src/sidebar/index';
import { fetchLogos } from '~src/sidebar/logo';

export const handleSidebarLogos = async () => {
  sidebarLoader('editor-sidebar-logo');

  await fetchLogos();

  displaySidebarLogos();
};
